import React, { useEffect, useRef } from 'react'
import { Send } from 'lucide-react'
import Reveal from '../components/Reveal'

function ShortcodeForm({ html }) {
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current || !html) return

    // Re-execute inline scripts (CF7 init)
    ref.current.querySelectorAll('script').forEach(old => {
      const s = document.createElement('script')
      Array.from(old.attributes).forEach(a => s.setAttribute(a.name, a.value))
      s.textContent = old.textContent
      old.parentNode.replaceChild(s, old)
    })

    // CF7 binds AJAX listeners via wpcf7.init() on DOMContentLoaded —
    // since that already fired, manually trigger init on the injected form.
    const form = ref.current.querySelector('.wpcf7-form')
    if (form && window.wpcf7) {
      window.wpcf7.init(form)
    }
  }, [html])

  return <div ref={ref} className="cp-form-wrap" dangerouslySetInnerHTML={{ __html: html }} />
}

function MockForm() {
  return (
    <form className="cp-mock-form" onSubmit={e => e.preventDefault()}>
      <div className="cp-mock-form__row">
        <input className="cp-mock-input" type="text"  placeholder="Full Name" />
        <input className="cp-mock-input" type="email" placeholder="Email Address" />
      </div>
      <div className="cp-mock-form__row">
        <input className="cp-mock-input" type="tel"  placeholder="Phone Number" />
        <input className="cp-mock-input" type="text" placeholder="Subject" />
      </div>
      <textarea className="cp-mock-input cp-mock-input--textarea" placeholder="Your message…" />
      <button type="submit" className="cp-mock-submit">
        Send Message <Send size={13} />
      </button>
    </form>
  )
}

export default function ContactForm({ formHtml }) {
  return (
    <Reveal variant="fade-left" delay={0.1} threshold={0.1} className="cp-form-col">
      <h2 className="cp-form-col__heading">Send Us a Message</h2>
      <p className="cp-form-col__sub">
        Fill in the form and our team will get back to you within 24 hours.
      </p>
      {formHtml ? <ShortcodeForm html={formHtml} /> : <MockForm />}
    </Reveal>
  )
}
